import { render, staticRenderFns } from "./ImageSettingsModal.vue?vue&type=template&id=1b159270&lang=pug"
import script from "./ImageSettingsModal.vue?vue&type=script&lang=js"
export * from "./ImageSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./ImageSettingsModal.vue?vue&type=style&index=0&id=1b159270&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports